<script>
export default {
  name: "ReservoirWaterRegime",
  data() {
    return {
      stcd: '',
      stnm: '',
      jczList: [],
      fastChoose: 'THIS_MONTH',
      fastList: [
        {label: '昨日', value: 'YESTERDAY'}, {label: '今日', value: 'TODAY'},
        {label: '上周', value: 'LAST_WEEK'}, {label: '本周', value: 'THIS_WEEK'},
        {label: '上旬', value: 'LAST_TENCENT'}, {label: '本旬', value: 'THIS_TENCENT'},
        {label: '上月', value: 'LAST_MONTH'}, {label: '本月', value: 'THIS_MONTH'},
        {label: '上季', value: 'LAST_SEASON'}, {label: '本季', value: 'THIS_SEASON'},
        {label: '去年', value: 'LAST_YEAR'}, {label: '本年', value: 'THIS_YEAR'},
        {label: '自定义', value: 'ZDY'}
      ],
      currentDate: this.$moment(new Date()).format('YYYY-MM-DD'),
      dataDate: [this.$moment(new Date()).format('YYYY-MM-DD'), this.$moment(new Date()).format('YYYY-MM-DD')],
      tableTitle: '水库水情报表',
      tableData: [],
      columns: [
        { label: '日期', prop: 'dt', align: 'center' },
        { label: '库水位（m）', prop: 'avz', align: 'right' },
        { label: '蓄水量（10⁴m³）', prop: 'avw', align: 'right' },
        { label: '入库流量（m³/s）', prop: 'inboundFlow', align: 'right' },
        { label: '出库流量（m³/s）', prop: 'outboundFlow', align: 'right' },
        { label: '汛限水位（m）', prop: 'fhxzsw', align: 'right' },
        { label: '设计水位（m）', prop: 'sjhsw', align: 'right' },
        { label: '超汛限（m）', prop: 'exceedFhxzsw', align: 'right' },
        { label: '超设计（m）', prop: 'exceedSjhsw', align: 'right' },
      ],
    }
  },
  methods: {
    onFastChoose(val) {
      this.fastChoose = val;
      this.query();
    },
    query() {
      let p = { stcd: this.stcd };
      if (this.fastChoose === 'ZDY') {
        p.dtGT = this.dataDate[0];
        p.dtLE = this.dataDate[1];
      } else {
        p.queryDateType = this.fastChoose;
      }

      this.request.get('/rm-report-water/v1/rsvr/report', { params: p }).then(
          (res) => {
            if (res.ok) {
              this.tableData = res.data.list;
              if(this.fastChoose ==='TODAY'||this.fastChoose ==='YESTERDAY'){
                this.tableTitle = `${res.data.dtstrGE} ${this.stnm}-` + '水库水情报表';
              }else{
                this.tableTitle = `${res.data.dtstrGE}至${res.data.dtstrLE} ${this.stnm}-` + '水库水情报表';
              }
            } else {
              this.$message.error(res.error);
            }
          }
      );
    },
    download() {
      let p = { stcd: this.stcd };
      if (this.fastChoose === 'ZDY') {
        p.dtGT = this.dataDate[0];
        p.dtLE = this.dataDate[1];
      } else {
        p.queryDateType = this.fastChoose;
      }

      this.request.get('/rm-report-water/v1/rsvr/export',{ params: p,responseType: "blob" }).then((res) => {
        try {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const a = document.createElement("a");
          a.href = URL.createObjectURL(blob);
          // 这里填保存成的文件名
          a.download = decodeURI(res.headers["content-disposition"].split(";")[1].split("=")[1]);
          a.click();
          URL.revokeObjectURL(a.href);
          return;
        } catch (error) {
          const reader = new FileReader();
          reader.readAsText(res.data, 'utf-8');
          let _this = this;
          reader.onload=function(){
            const msg = JSON.parse(reader.result);
            if (!msg.ok) {
              if (msg.error.code === 3001) {
                _this.$message.error(msg.error.message);
              } else {
                _this.$message.warning(msg.error.message);
              }
            }
          }
        }
      });
    },
    init() {
      this.request.get('/rm-bstmp/queryByMstp/0607').then(
          (res) => {
            if (res.ok) {
              this.jczList = res.data;
              this.stcd = res.data[0]?.k;
              this.stnm = res.data[0]?.v;
              this.query();
            }
          }
      );
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (row.stnm === '面雨量') {
        if (columnIndex === 0) {
          return [1, 2];
        } else if (columnIndex === 1) {
          return [0, 0];
        }
      }
    },
  },
  mounted() {
    this.init();
  },
  watch:{
    "$store.state.head.skCd"() {
      //调用页面查询方法
      this.init();
    },
  }
}
</script>

<template>
  <el-container style="padding: 20px 0;">
    <el-header class="header">
      <el-select v-model="stcd" size="small" style="width: 20rem;margin-right: 20px;" disabled>
        <el-option
            v-for="item in jczList"
            :key="item.k"
            :label="item.v"
            :value="item.k">
        </el-option>
      </el-select>
      <el-button
          type="text"
          v-for="item in fastList"
          :class="fastChoose === item.value ? 'chooseActive':'choose'"
          @click="onFastChoose(item.value)">
        {{item.label}}
      </el-button>
      <el-date-picker
          v-if="fastChoose === 'ZDY'"
          style="margin-left: 20px;margin-right: 20px;"
          v-model="dataDate"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          type="daterange"
          size="mini"
          :clearable="false"
          placeholder="选择日期">
      </el-date-picker>
      <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="query">
        搜索
      </el-button>
      <el-button
          type="primary"
          size="small"
          class="queryButton queryButtonPadding qDcBtn"
          @click="download">
        <el-image class="qDcImg" :src="require('@/assets/buttonGathers/query-dc.png')"></el-image>
        &nbsp;导出
      </el-button>
    </el-header>
    <el-main style="padding: 20px 0;">
      <el-table
          :data="tableData"
          :span-method="arraySpanMethod"
          style="width: 100%;"
          border
          :header-cell-style="{backgroundColor:'white',fontSize: '1.4rem',textAlign:'center',color:'#323232',
                          fontFamily:'PingFang SC',fontWeight:'bold',fontStretch:'normal',height:'3vh'}"
          height="calc(100vh - 320px)"
          max-height="calc(100vh  - 320px)">
        <el-table-column align="center">
          <template #header>
            <label style="font-size: 28px">{{tableTitle}}</label>
          </template>
          <el-table-column
              v-for="item in columns"
              :label="item.label"
              :prop="item.prop"
              :key="item.prop"
              :align="item.align"
              header-align="center">
          </el-table-column>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>

<style scoped>
.header {
  height: 50px;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  position: relative;
}

.chooseActive{
  color:#409EFF;
  margin-left: 2rem;
  float: left;
}

.choose{
  color:#909399;
  margin-left: 2rem;
  float: left;
}
</style>